import { useWindowDimensions } from 'react-native';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';

const TABLET_BREAKPOINT = 768;
const DESKTOP_BREAKPOINT = 1024;
const LARGE_DESKTOP_BREAKPOINT = 1440;
const SIDEBAR_WIDTH = 220;
const SUMMARY_PANEL_WIDTH = 260;
const CONTENT_MAX_WIDTH = 900;

export function useDesktopLayout() {
  const { width: screenWidth } = useWindowDimensions();
  const accountType = useSelector((state: RootState) => state.UI.accountType);

  const isDesktop = screenWidth >= TABLET_BREAKPOINT;
  const isProducer = accountType === 'producer';
  const isLargeScreen = screenWidth >= DESKTOP_BREAKPOINT;
  const isLargeDesktop = screenWidth >= LARGE_DESKTOP_BREAKPOINT;
  const showSummaryPanel = isDesktop && isLargeDesktop;
  const contentMaxWidth = isDesktop ? CONTENT_MAX_WIDTH : undefined;

  return {
    isDesktop,
    isProducer,
    isLargeScreen,
    isLargeDesktop,
    showSummaryPanel,
    contentMaxWidth,
    screenWidth,
    sidebarWidth: SIDEBAR_WIDTH,
    summaryPanelWidth: SUMMARY_PANEL_WIDTH,
    TABLET_BREAKPOINT,
    DESKTOP_BREAKPOINT,
    LARGE_DESKTOP_BREAKPOINT,
  };
}
